import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import sanitizeHtml from 'sanitize-html'

import Typography from '@segment/matcha/components/Typography'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'

import type { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import accordionData from 'views/Infrastructure/accordionData'

import { useActiveState } from '@segment/utils/useActiveState'

interface AccordionSectionProps {
  section: SectionWithAccordion
}

const AccordionSection: FC<PropsWithChildren<AccordionSectionProps>> = ({ section }) => {
  const data = accordionData[section]
  const items = new Array(data.length).fill(false)
  const { activeItems, toggle } = useActiveState(items, {
    allowMultipleActive: true,
  })
  return (
    <Wrapper>
      {activeItems.map((active, index) => (
        <AccordionBase key={`item-${index}`}>
          <Accordion.Header onClick={() => toggle(index)}>
            <Accordion.TitleWrapper>
              <Accordion.Title variant="h5" tag="h4" opened={active}>
                {data[index].title}
              </Accordion.Title>
            </Accordion.TitleWrapper>
            <Accordion.Icon opened={active} />
          </Accordion.Header>
          <Accordion.Body>
            {active && (
              <Accordion.ContentWrapper>
                <AccordionContent
                  variant="pMedium"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(data[index].description, { allowedTags: [`a`] }),
                  }}
                />
              </Accordion.ContentWrapper>
            )}
          </Accordion.Body>
        </AccordionBase>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow-y: hidden;
`

const AccordionContent = styled(Typography)`
  margin: 0;
`

export default AccordionSection
